// import {routerReducer as routing} from 'react-router-redux';
import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';
import auth from './auth';
import app from './app';
import user from './user';
import header from './header';
import banner from './banner';
import scoreBoard from './scoreBoard';
import intl from './intl';
import toolbox from './toolbox';
import faq from './faq';
import home from './home';
import alert from './alert';
import SRview from './SRview';
import serviceCatalog from './serviceCatalog';
import Search from './search';
import MySettings from './mySettings';
import news from './news';

export default combineReducers({
  app,
  auth,
  user,
  header,
  banner,
  home,
  scoreBoard,
  serviceCatalog,
  browser: createResponsiveStateReducer({
    xxSmall: 479,
    extraSmall: 767,
    small: 991,
    medium: 1199,
    large: 2560
  }),
  intl,
  faq,
  toolbox,
  alert,
  SRview,
  Search,
  MySettings,
  news
});



// WEBPACK FOOTER //
// ./reducers/index.js